function objectToQueryString(obj) {
  const keyValuePairs = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key];

      if (value === undefined || value === null) continue;
      if (Array.isArray(value)) {
        value = value.join(',')
      }
      const encodedPair = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

      keyValuePairs.push(encodedPair);
    }
  }

  return keyValuePairs.join('&');
}


async function getFilteredCourses(filterUrl) {
  const response = await fetch(filterUrl);
  if (response.ok) {
    const data = await response.json();
    if (!data.results) {
      return [];
    }
    return data.results;
  } else {
    throw new Error('Unable to fetch courses.');
  }
}

function createFilterUrl(apiUrl, filter) {
  console.log("filter", filter);
  if (!filter || !filter.query || filter.query == "" ) {
    filter = filter || {};
    filter.query = "";
  }
  let filterUrl = apiUrl + '?' + objectToQueryString(filter)
  // if (filter.types) {
  //   filterUrl += "&types=" + filter.types
  // }

  // if (filter.tag) {
  //   filterUrl += "&tag=" + filter.tag
  // }
  // if (filter.cat) {
  //   filterUrl += "&cat=" + filter.cat
  // }

  // if (filter.page) {
  //   filterUrl += "&page=" + filter.page
  // }

  // if (filter.count) {
  //   filterUrl += "&count=" + filter.count
  // }


  return filterUrl;
}

export { getFilteredCourses, createFilterUrl };
